import type { FilterEventPayload } from '../types/analytics-events.ts';

/**
 * Extracts active filter IDs from a filters object and returns the analytics event payload.
 * Excludes non-filter fields like sortingFilter, sort and limit which are display/pagination settings.
 * Returns null if no active filters are found.
 */
export function getUsedFilterEventPayload(
    filters: Record<string, unknown>,
    excludeFields: string[] = ['sortingFilter', 'sort', 'limit'],
): FilterEventPayload {
    const activeFilterIds = Object.entries(filters)
        .filter(
            ([filterId, filterValue]) =>
                !excludeFields.includes(filterId) &&
                filterValue !== undefined &&
                filterValue !== null &&
                filterValue !== '' &&
                (Array.isArray(filterValue) ? filterValue.length > 0 : true),
        )
        .map(([filterId]) => filterId);

    return { filters: activeFilterIds };
}
